const GenerateIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/generate-icon.svg"
            alt="Document Icon"
        />
    );
};

export default GenerateIcon;
